import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState } from "react";
import { toast } from "sonner";
import {
  LuMail, LuPhone, LuMapPin, LuLinkedin, LuTwitter,
  LuInstagram, LuArrowRight, LuSend
} from 'react-icons/lu';

const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Technologies', path: '/technologies' },
  { name: 'Blog', path: '/blog' },
  { name: 'Careers', path: '/careers' }
];

const services = [
  { name: 'Custom Software Development', path: '/services' },
  { name: 'Mobile App Development', path: '/services' },
  { name: 'AI & Machine Learning', path: '/technologies/genai' },
  { name: 'Digital Marketing', path: '/services' },
  { name: 'Cloud & DevOps', path: '/technologies/cloud' },
  { name: 'UI/UX Design', path: '/services' }
];

const technologies = [
  { name: 'Frontend Engineering', path: '/technologies/frontend' },
  { name: 'Backend Engineering', path: '/technologies/backend' },
  { name: 'Generative AI', path: '/technologies/genai' },
  { name: 'Cloud & DevOps', path: '/technologies/cloud' },
  { name: 'Mobile Development', path: '/technologies/mobile' },
  { name: 'Data Engineering', path: '/technologies/data' }
];

export const Footer = () => {

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("https://formspree.io/f/mykndjwo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        toast.success("Subscribed successfully!");
        setEmail("");
      } else {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      toast.error("Network error.");
    }

    setLoading(false);
  };
  return (
    <footer className="bg-slate-950 relative overflow-hidden" data-testid="footer">
      {/* Top gradient line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent" />

      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-600/5 rounded-full blur-3xl" />

      {/* Newsletter Section */}
      <div className="border-b border-slate-800/50">
        <div className="container mx-auto px-4 md:px-8 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">

            <div className="text-center md:text-left">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-2">
                Stay Updated with <span className="text-gradient-orange">TechMeetsU</span>
              </h3>
              <p className="text-slate-400 text-sm">
                Get the latest insights on technology, AI, and digital growth strategies
              </p>
            </div>

            {/* FORM START */}
            <form
              onSubmit={handleNewsletterSubmit}
              className="flex gap-3 w-full md:w-auto"
            >
              <div className="relative flex-1 md:w-72">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full bg-slate-900/50 border border-slate-700 rounded-xl px-4 py-3 text-white placeholder:text-slate-500 focus:outline-none focus:border-orange-500/50 transition-colors"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="bg-gradient-to-r from-orange-600 to-orange-500 hover:from-orange-500 hover:to-orange-400 text-white px-5 py-3 rounded-xl font-semibold transition-all flex items-center gap-2 whitespace-nowrap"
              >
                {loading ? (
                  "Subscribing..."
                ) : (
                  <>
                    <span className="hidden sm:inline">Subscribe</span>
                    <LuSend size={18} />
                  </>
                )}
              </button>
            </form>
            {/* FORM END */}

          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 md:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-6">
            <Link to="/" className="inline-block group">
              <div className="flex items-center gap-3">
                <img
                  src="https://customer-assets.emergentagent.com/job_innovate-tech-4/artifacts/656jawr7_withoutBg.png"
                  alt="TechMeetsU"
                  className="h-12 w-auto"
                />
                <div>
                  <div className="text-white font-heading font-bold text-xl group-hover:text-orange-400 transition-colors">
                    TechMeetsU
                  </div>
                  <div className="text-[10px] text-slate-500 uppercase tracking-wider">
                    Where Tech Meets You
                  </div>
                </div>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              Your complete technology & digital growth partner. From custom software development
              to AI integration and digital marketing — we deliver end-to-end solutions that drive
              real business growth.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              <a
                href="mailto:admin@techmeetsu.com"
                className="flex items-center gap-3 text-slate-400 hover:text-orange-400 transition-colors group"
              >
                <div className="w-9 h-9 rounded-lg bg-slate-800/50 border border-slate-700 flex items-center justify-center group-hover:border-orange-500/50 transition-colors">
                  <LuMail size={16} />
                </div>
                <span className="text-sm">admin@techmeetsu.com</span>
              </a>
              <a
                href="tel:+919152929786"
                className="flex items-center gap-3 text-slate-400 hover:text-orange-400 transition-colors group"
              >
                <div className="w-9 h-9 rounded-lg bg-slate-800/50 border border-slate-700 flex items-center justify-center group-hover:border-orange-500/50 transition-colors">
                  <LuPhone size={16} />
                </div>
                <span className="text-sm">+91 91529 29786</span>
              </a>
              <div className="flex items-center gap-3 text-slate-400">
                <div className="w-9 h-9 rounded-lg bg-slate-800/50 border border-slate-700 flex items-center justify-center">
                  <LuMapPin size={16} />
                </div>
                <span className="text-sm">Mumbai, India</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-3 pt-2">
              <a
                href="https://linkedin.com/company/techmeetsu"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-slate-800/50 border border-slate-700 flex items-center justify-center text-slate-400 hover:text-white hover:border-blue-500/50 hover:bg-blue-500/10 transition-all"
                data-testid="social-linkedin"
              >
                <LuLinkedin size={18} />
              </a>
              <a
                href="https://twitter.com/techmeetsu"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-slate-800/50 border border-slate-700 flex items-center justify-center text-slate-400 hover:text-white hover:border-blue-400/50 hover:bg-blue-400/10 transition-all"
                data-testid="social-twitter"
              >
                <LuTwitter size={18} />
              </a>
              <a
                href="https://instagram.com/techmeetsu"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-slate-800/50 border border-slate-700 flex items-center justify-center text-slate-400 hover:text-white hover:border-pink-500/50 hover:bg-pink-500/10 transition-all"
                data-testid="social-instagram"
              >
                <LuInstagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-5 flex items-center gap-2">
              <span className="w-6 h-px bg-orange-500"></span>
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-orange-400 text-sm transition-colors flex items-center gap-2 group"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    <LuArrowRight size={12} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    <span className="group-hover:translate-x-1 transition-transform">{link.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-5 flex items-center gap-2">
              <span className="w-6 h-px bg-blue-500"></span>
              Services
            </h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.name}>
                  <Link
                    to={service.path}
                    className="text-slate-400 hover:text-blue-400 text-sm transition-colors flex items-center gap-2 group"
                  >
                    <LuArrowRight size={12} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    <span className="group-hover:translate-x-1 transition-transform">{service.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Technologies */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-5 flex items-center gap-2">
              <span className="w-6 h-px bg-orange-500"></span>
              Technologies
            </h3>
            <ul className="space-y-3">
              {technologies.map((tech) => (
                <li key={tech.name}>
                  <Link
                    to={tech.path}
                    className="text-slate-400 hover:text-orange-400 text-sm transition-colors flex items-center gap-2 group"
                  >
                    <LuArrowRight size={12} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    <span className="group-hover:translate-x-1 transition-transform">{tech.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800/50">
        <div className="container mx-auto px-4 md:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} TechMeetsU. All rights reserved.
            </p>

          </div>
        </div>
      </div>
    </footer>
  );
};
